import { render } from "./LyricsEyesOfFire.vue?vue&type=template&id=0e3ed252&scoped=true"
import script from "./LyricsEyesOfFire.vue?vue&type=script&lang=js"
export * from "./LyricsEyesOfFire.vue?vue&type=script&lang=js"

import "./LyricsEyesOfFire.vue?vue&type=style&index=0&id=0e3ed252&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3ed252"]])

export default __exports__